import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const FranchiseEnquiryService = {
  // Define your API functions here

  create: async (data) => {
    const response = await apiService.post("/franchiseinquiry", data);
    return response.data;
  },

  getList: async ({ page, pageSize, search }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      pageNumber: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/franchiseinquiry?${params}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/franchiseinquiry/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/franchiseinquiry/${id}`);
    return response.data;
  },
  UpdateStatus: async (id, data) => {
    const response = await apiService.put(`/franchiseinquiry/${id}`, data);
    return response.data;
  },
};

export default FranchiseEnquiryService;
